/**
 * Backend Realtime API Entity
 *
 * OpenAI Realtime API + RAG + 인터넷 검색 통합
 */

// API
export { BackendRealtimeAPI } from './api/backend-realtime-api';
export type { BackendRealtimeConfig, MessageHandler } from './api/backend-realtime-api';

// Types
export type {
  ClientMessage,
  ServerMessage,
  TextMessage,
  TextWithRagMessage,
  SetWebSearchMessage,
  SessionReadyMessage,
  ResponseTextDeltaMessage,
  ResponseDoneMessage,
  SearchStartedMessage,
  SearchCompletedMessage,
  RagContextMessage,
  WebSearchUpdatedMessage,
  ErrorMessage,
  ConnectionState,
  SearchState,
  WebSearchModeResponse,
  SessionInfoResponse,
} from './types/messages';

// Constants
export { getRealtimeWsUrl, REALTIME_API_BASE, getSessionInfoUrl, getSearchModeUrl } from './const/endpoint';

// Model (Hooks)
export { useBackendRealtime } from './model/use-backend-realtime';
export type { UseBackendRealtimeProps, UseBackendRealtimeReturn } from './model/use-backend-realtime';
